var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoldenLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 159,
    viewBox: "0 0 146 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.055 56.5593V52.7312C145.055 48.8911 144.068 45.1184 142.192 41.7926C140.317 38.4668 137.619 35.7051 134.37 33.785L83.6804 3.83302C80.432 1.91311 76.747 0.902344 72.996 0.902344C69.245 0.902344 65.56 1.91311 62.3116 3.83302L11.6219 33.7932C8.37314 35.7133 5.67541 38.4751 3.79988 41.8008C1.92435 45.1266 0.937126 48.8993 0.9375 52.7395V57.8773L7.74615 61.2788V54.9516C7.74576 51.6613 8.59181 48.4289 10.1992 45.5796C11.8066 42.7304 14.1186 40.3646 16.9027 38.7205L61.9937 12.0716V24.8847L18.5989 50.5438V110.481L61.9937 136.129V148.942L16.9027 122.298C14.1184 120.653 11.8063 118.286 10.1989 115.436C8.59158 112.586 7.74563 109.353 7.74615 106.062V70.3842L0.9375 66.9827V108.271C0.937126 112.111 1.92435 115.884 3.79988 119.21C5.67541 122.536 8.37314 125.297 11.6219 127.217L62.2555 157.139C63.2889 157.749 64.3699 158.271 65.4875 158.698V10.0017L68.3937 8.2845C69.8269 7.43656 71.4528 6.98957 73.1082 6.98842H73.1403C74.9382 6.98977 76.6985 7.51521 78.2154 8.50326L80.5018 10.0017V158.703C81.6222 158.28 82.7052 157.759 83.7392 157.148L134.367 127.226C137.616 125.306 140.314 122.544 142.189 119.218C144.065 115.892 145.052 112.12 145.052 108.279V65.6975L138.243 69.1755V106.051C138.244 109.341 137.398 112.574 135.792 115.424C134.186 118.274 131.875 120.641 129.092 122.287L84.001 148.936V136.129L127.39 110.47V50.5438L84.001 24.8902V12.0716L129.089 38.7205C131.872 40.3658 134.183 42.7319 135.789 45.581C137.395 48.4301 138.241 51.6619 138.24 54.9516V60.0347L145.055 56.5593ZM61.983 92.6116L25.5892 70.4416V54.6863L61.983 33.178V92.6116ZM101.272 78.9399L109.433 83.9109L120.384 90.5827V106.324L83.9956 127.833V68.4072L101.272 78.9399Z",
    fill: "url(#paint0_linear_1239_19638)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1239_19638",
    x1: 72.996,
    y1: -5.68251,
    x2: 72.996,
    y2: 165.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B16D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F1AA36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FCD74E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F1AA36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E38C05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FCD74E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F1AA36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B16D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1AA36"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldenLogo);
export default __webpack_public_path__ + "static/media/golden-logo.e33706bfb5b9a6eeaf5ab0633d3599b2.svg";
export { ForwardRef as ReactComponent };